import { Grid, Box, Typography, useMediaQuery, Button } from "@mui/material";

import makeStyles from '@mui/styles/makeStyles';

import AdditionalContentBlockText from "../../Components/Block/AdditionalContentBlockText";
import DownloadContentBlock from "../../Components/Block/DownloadContentBlock";
import EntryHeader from "../../Layouts/EntryHeader";
import GetAppIcon from '@mui/icons-material/GetApp';
import IconButtonBlock from "../../Components/Block/IconButtonBlock";
import React, { memo, useCallback, useMemo, useState } from "react";
import EntrySummary from "../../Components/Entry/EntrySummary";
import { getPlayer } from "../../Utils/Api";
import { showVideo } from "../../Utils/Video";
import Slider from "../../Components/Gallery/Slider";
import Slide from "../../Components/Gallery/Slide";
import theme from "../../theme";
import { generatePathAward, generatePathMyList, getQueryParams, generatePathCategory, generatePathCategoryEntry, generatePathEntry } from "../../Utils/Routes";
import { goToDownload } from "../../Utils/Download";
import {getAvailableDataItems, getEntryAvailabilityTagsMap, useGameAvailability, useMyListEntries} from "../../Utils/Entry";
import Header from "../../Layouts/Header";
import LoadingSpinner from '../../Components/LoadingSpinner';
import {Link, useLocation, useParams} from 'react-router-dom';
import EntryGalleryDialog, { useLoadEntryImages } from "../../Components/Dialog/EntryGalleryDialog";
import Page from "../../Components/Page";
import { useAwards } from "../../Utils/Award";
import ListViewEntryList from "../../Components/Entry/List/ListViewEntryList";
import { EntryCategoryLinkBlock, EntryTagLinkBlock } from "../../Components/Block/EntryCategoryLinkBlock";
import { useScrollToTop } from "../../Utils/ScrollToTop";
import { toEntryData } from "../../Components/Entry/List/GenericEntryList";
import { useAwardEntries } from "../../Utils/Entry";

const useStyles = makeStyles((theme) => ({
    wrapper: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),

        [theme.breakpoints.up("sm")]: {
            paddingLeft: theme.spacing(6),
            paddingRight: theme.spacing(6),
            paddingTop: theme.spacing(3),
        },
    },
    viewallBtn: {
        display: 'flex',
        justifyContent: 'flex-end',
        '& .MuiTypography-root': {
            color: 'white'
        }
    },
    nextToMyList: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2)
    },
    categoryWrapper: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        // '& .block': {
        //     padding: '0.5rem',
        //     justifyContent: 'flex-start'
        // },
        // '& .block__inner': {
        //     paddingLeft: '15px'
        // }
    },
    videosWrapper: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    additionalContentWrapper: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        '& button': {
            width: '100%',
        },
    }
}));


export default function EntryPage({ ...props }) {
    const location = useLocation();
    const urlParams = useParams();
    const entryId = parseInt(urlParams.entryId);
    const awardId = parseInt(urlParams.awardId);
    const categoryId = urlParams.categoryId ? parseInt(urlParams.categoryId) : null;

    useScrollToTop();

    const classes = useStyles();

    const isMobile = useMediaQuery(theme.breakpoints.down('sm'), {
        defaultMatches: true
    });
    const isTablet = useMediaQuery(theme.breakpoints.down('md'), {
        defaultMatches: true
    });

    const numItemsPerSlide = isMobile ? 1 : (isTablet ? 3 : 6);

    const awards = useAwards();
    console.log("awards", awards);
    const award = useMemo(() => awards?.find(award => ""+award.awardId === ""+awardId), [awards, awardId]);
    console.log("award", award);

    const entries = useAwardEntries(award);
    console.log("entries", entries);
    const entry = useMemo(() => entries?.find(entry => ""+entry.id === ""+entryId), [entries, entryId]);
    console.log("entry", entry);

    const myListEntries = useMyListEntries(awards);
    const displayMyListEntries = useMemo(() => toEntryData(myListEntries?.slice(0, 10)), [myListEntries]);

    const [disableButton, setDisableButton] = useState(false);
    //const filters = useSelector(selectFilters);
    const loading = !entry || !award;
    // TODO: replace with backURL queryString
    const { bup } = getQueryParams(location.search.replace(/^\?/, ''));
    const backUrlParams = bup ? decodeURIComponent(bup) : null;

    const [state, setState] = React.useState({
        openImagesItem: null,
    });

    const handleClickOpen = (slide) => {
        setState(state => ({
            ...state,
            openImagesItem: slide,
        }));
    };
    function handleGalleryDialogClose() {
        setState(state => ({
            ...state,
            openImagesItem: null,
        }));
    }

    const entryPageMyListLinkComponent = memo(useCallback(function EntryPageMyListLinkComponent({ entry, entryCategoryId = null, ...props }) {

        const awardId = entry.awardId;

        const linkCategoryId = entryCategoryId ?? categoryId;

        const baseEntryLink = linkCategoryId
            ? generatePathCategoryEntry(awardId, linkCategoryId, entry.id)
            : generatePathEntry(awardId, entry.id)

        const entryLink = baseEntryLink;

        return <Link to={entryLink} {...props} />;
    }, [categoryId]));

    const onlyInMyList = location.search.includes("from=mylist")
    const backUrl = (
            onlyInMyList
                ? generatePathMyList()
                : (
                    categoryId 
                        ? generatePathCategory(awardId, categoryId) 
                        : generatePathAward(awardId) 
                ) 
        )
        + `?${backUrlParams ?? ""}&scrollId=e${entryId}`
    ;


    const descriptions = useMemo(() => {
        if(!entry) return null;
        
        return getAvailableDataItems(entry?.data, "additionalImageDescription")
            .filter(item => item && item.answer && !item.mediaItem)
            .filter(content => {
                if(entry.hasCategoryPage && content.specificToCategoryIds.length > 0){
                    return content.specificToCategoryIds.find(catId => ""+catId === ""+categoryId);
                } else {
                    return true;
                }
            })
        },
        [categoryId, entry]
    );
    console.log("descriptions", descriptions);
        
    const images = useMemo(() => {
        if(!entry || !descriptions) return null;

        return getAvailableDataItems(entry.data, "additionalImage")
            .filter(item => item && item.answer && item.mediaItem && item.thumbnailUrl && item.thumbnailUrl !== "__FAILED__")
            .filter(content => {
                if(entry.hasCategoryPage && content.specificToCategoryIds.length > 0){
                    return content.specificToCategoryIds.find(catId => ""+catId === ""+categoryId);
                } else {
                    return true;
                }
            })
            .map(item => ({
                id: item.answer,
                //src: item.originalUrl,
                thumbnailSrc: item.thumbnailUrl,
                title: item.title,
                description: descriptions
                    .find(descItem => descItem.keyId === item.keyId)
                    ?.answer ?? null,
            }))
        },
        [categoryId, descriptions, entry]
    );
    console.log("images", images);
    
    const galleryImages = useLoadEntryImages(awardId, entryId, images);
    console.log("galleryImages", galleryImages);


    function handleImageChange(newImage) {
        setState(state => ({
            ...state,
            openImagesItem: images.find(image => image.id === newImage.id),
        }));
    }

    const gameAvailability = useGameAvailability(awardId);
    const entryAvailibilityTagsMap = getEntryAvailabilityTagsMap(gameAvailability?.platforms);
    console.log("entryAvailibilityTagsMap?.[entryId]", entryAvailibilityTagsMap?.[entryId]);

    if(!entry) {
        return loading
            ? <LoadingSpinner/> 
            : (
                <>
                    <Header/>
                    <EntryHeader
                        isMobile={props.isMobile}
                        title="No content found."
                        backUrl={backUrl}
                    />
                    <Box style={{display: "flex", alignItems: "center", justifyContent: "center", height: '50vh'}}>
                        <Typography variant="h6">
                            The content you are trying to access is no longer available to view.
                            Please contact voting@bafta.org with any questions.
                        </Typography>
                    </Box>
                </>
            );
    }

    function onPlayVideo(contentItem) {
        setDisableButton(true);
        (async () => {
            const resp = await getPlayer(awardId, entryId, contentItem.answer);

            if(resp.data.status === "ERROR") {
                const html = `
                    <html><body>
                        <table style=\\"font-family:sans-serif;\\" width=\\"100%\\" height=\\"100%\\">
                            <tr valign=\\"middle\\">
                                <td align=\\"middle\\">
                                    <p>${resp.data.errorMessage}</p>
                                </td>
                            </tr>
                        </table>
                    </body></html>
                `;
    
                showVideo('', {
                    width: 660,
                    height: 500
                }, html);
            }
            else if("size" in resp.data) {
                showVideo(resp.data.url, {
                    ...resp.data.size,
                });
                setDisableButton(false);
            }
        })();
    }

    const synopsis = entry.data?.synopsis?.answer;

    const normalisedCategories = entry.categories ?? {};
    const tags = [...(entry.tags ?? []), ...(entryAvailibilityTagsMap?.[entryId] ?? [])].sort();

    // create separate category items for each candidate for nomination
    const categories = Object.values(normalisedCategories)
        .map(category =>
            // create an array the length of the candidatesForNomination array (but make sure its at least 1 item long)
            [...Array(Math.max(1, category.candidatesForNomination.length))]
                // map over the array and add the category to each item + the candidate at this index
                .map((x, i) => ({
                        id: category.id,
                        title: category.title.trim(),
                        candidatesForNomination: undefined,
                        candidateForNomination: category.candidatesForNomination && category.candidatesForNomination.length ? category.candidatesForNomination[i].trim() : null,
                    })
                ))
        // for each category we will get back a sub-array of categories so flatten all categories into one array
        .flat()
        // order alphabetically by category title then by candidate name
        .sort((a, b) => {
            // sort by title
            const compareResult = a.title.localeCompare(b.title)
            // if not the same title then return the ordering
            if(compareResult !== 0) return compareResult;
            // else try and sort by candiadte anme
            const aCandidate = a.candidateForNomination ?? "";
            const bCandidate = b.candidateForNomination ?? "";
            //console.log(`candidates: '${aCandidate}' '${bCandidate}' ${aCandidate.localeCompare(bCandidate)}`);
            return aCandidate.localeCompare(bCandidate);
        });
    
    const additionContentItems = getAvailableDataItems(entry.data, "additionalContent")
        .filter(item => item && item.answer
            // if the item is a media item, make sure it is downloadable (otherwise there's nothing we cant do with it)
            && (!item.mediaItem || item.allowDownload)
            // this should be fixed in the API
            && item.answer !== "0")
        .filter(content => {
            if(entry.hasCategoryPage && content.specificToCategoryIds.length > 0){
               return content.specificToCategoryIds.find(catId => ""+catId === ""+categoryId);
            } else {
                return true;
            }
        });
    
    const additionalVideos = getAvailableDataItems(entry.data, "additionalVideo")
        .filter(item => item && item.answer && item.mediaItem)
        .filter(content => {
            if(entry.hasCategoryPage && content.specificToCategoryIds.length > 0){
                return content.specificToCategoryIds.find(catId => ""+catId === ""+categoryId);
            } else {
                return true;
            }
        });
    
    return (
        <Page title={entry.title}>
            <Header />
            <EntryHeader isMobile={props.isMobile} title={entry.title} backUrl={backUrl} number="10" />
            <Grid container className={classes.wrapper} >
                <Grid item md={12} xs={12}>
                    <Grid container>
                        <Grid item md={12} xs={12}>
                            <EntrySummary
                                content={synopsis}
                                award={award}
                                entry={entry}
                                categoryId={categoryId}
                            />
                        </Grid>
                    </Grid>

                    {!additionContentItems || !additionContentItems.length ? "" : (
                        <Grid container className={classes.additionalContentWrapper} spacing={3}>
                            <Grid item md={12} xs={12}>
                                <Typography component="h5" variant="h5" className="upper">Additional Content</Typography>
                            </Grid>
                            {additionContentItems.map((contentItem, i) => (
                                <Grid key={i} item md={3} xs={12}>
                                    {contentItem.mediaItem 
                                        ? (
                                            <IconButtonBlock
                                                heading={contentItem.title}
                                                icon={GetAppIcon}
                                                onClick={() => goToDownload(awardId, entryId, contentItem.answer)} 
                                            />
                                        ):(
                                            <AdditionalContentBlockText entryTitle={entry.title} title={contentItem.title} content={contentItem.answer} />
                                        )
                                    }
                                </Grid>
                            ))}
                        </Grid>
                    )}

                    {!additionalVideos || !additionalVideos.length ? "" : (
                        <Grid container className={classes.videosWrapper} spacing={3}>
                            <Grid item md={12} xs={12}>
                                <Typography component="h5" variant="h5" className="upper">Videos</Typography>
                            </Grid>
                            {additionalVideos.map((contentItem, i) => (
                                <Grid key={i} item md={3} xs={12}>
                                    <DownloadContentBlock
                                        heading={contentItem.title}
                                        allowDownload={contentItem.allowDownload}
                                        fileSize={contentItem.size || null}
                                        onPlay={() => onPlayVideo(contentItem)}
                                        onDownload={() => goToDownload(awardId, entryId, contentItem.answer)}
                                        loading={disableButton}
                                    />
                                </Grid>
                            ))}
                        </Grid>
                    )}

                    {images && images.length ? (
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <Slider heading="Photos" ofText={(slideIndex) => `${slideIndex*numItemsPerSlide+1} - ${Math.min((slideIndex+1)*numItemsPerSlide, images.length)} of ${images.length} photos`}>
                                    {chunk(images, numItemsPerSlide).map((slideImages, i) => (
                                        <Slide key={i}>
                                            <Grid container style={{display: "flex"}} spacing={3}>
                                                {slideImages.map((image) => (
                                                    <Grid item xs={12} sm={4} md={2} key={image.id} style={{padding: '1rem'}}>
                                                        <Button style={{paddingTop: "100%", position: "relative", display: "block", width: "100%"}} onClick={() => handleClickOpen(image)}>
                                                            <img src={image.thumbnailSrc} alt="" style={{
                                                                position: "absolute",
                                                                top: 0, left: 0,
                                                                width: "100%",
                                                                height: "100%",
                                                                objectFit: "cover",
                                                            }} />
                                                        </Button>
                                                    </Grid>
                                                ))}
                                            </Grid>
                                        </Slide>
                                    ))}
                                </Slider>

                                {galleryImages?.images && Boolean(state?.openImagesItem) ? (
                                    <EntryGalleryDialog 
                                        handleClose={handleGalleryDialogClose} 
                                        open={Boolean(state?.openImagesItem)} 
                                        images={galleryImages?.images} 
                                        currentImageId={state?.openImagesItem?.id} 
                                        reloadImage={galleryImages.reloadImage}
                                        onImageChange={handleImageChange}
                                    />
                                ) : ""}
                            </Grid>
                        </Grid>
                    ):""}


                    {!categories?.length ? "" : (
                        <Grid container className={classes.categoryWrapper} spacing={3}>
                            <Grid item md={12} xs={12}>
                                <Typography component="h5" variant="h5" className="upper">Categories</Typography>
                                <Typography variant="body1" component="div" style={{marginTop: ".6em"}}>
                                    <p>This entry has been submitted in the categories listed below.</p>
                                    <p>For Film or Game entries, click on a category to review all entries in that category.</p>
                                    <p>
                                        For Television programmes, each listing represents an episode, so ensure you check the full entry list per category as there may be more entries for this programme. Note that entries will be added up until voting begins. For further information please contact <a href="mailto:voting@bafta.org">voting@bafta.org</a>.
                                    </p>
                                </Typography>
                            </Grid>
                            {categories.map(category => (
                                <Grid key={""+category.id+category.candidateForNomination} item md={3} xs={12}>
                                    <EntryCategoryLinkBlock 
                                        entry={entry}
                                        awardId={awardId} 
                                        category={category} 
                                    />
                                </Grid>
                            ))}
                        </Grid>
                    )}

                    {!tags?.length ? "" : (
                        <Grid container className={classes.categoryWrapper} spacing={3}>
                            <Grid item md={12} xs={12}>
                                <Typography component="h5" variant="h5" className="upper">TAGS</Typography>
                                <Typography variant="body1" component="p" style={{marginTop: ".6em"}}>To review all the published entries that have been tagged with a specific status  you can click on a tag below. Note that more entries may be updated during the viewing period. For a full list please refer to the list sent by the Membership Team.</Typography>
                            </Grid>
                            {tags.map((tag, idx) => (
                                <Grid key={idx} item md={3} xs={12}>
                                    <EntryTagLinkBlock entry={entry} awardId={awardId} categoryId={categoryId} tagName={tag} />
                                </Grid>
                            ))}
                        </Grid>
                    )}

                    {
                        displayMyListEntries?.length > 0 ?
                            <Grid container spacing={3}>
                                <Grid container item direction="row" className={classes.nextToMyList}>
                                    <Grid item md={8} xs={6}>
                                        <Typography component="h5" variant="h5">NEXT ON MY LIST</Typography>                                            
                                    </Grid>
                                    <Grid item md={4} xs={6} className={classes.viewallBtn}>
                                    <Link to={ generatePathMyList() } style={{textDecoration:"none", color:'white'}}>
                                        <Typography component="h6" variant="button" style={{paddingTop: '0.35rem'}}>VIEW ALL</Typography>
                                        </Link>
                                    </Grid>
                                </Grid>
                                <Grid container item>
                                    <Grid item md={12} >
                                        <ListViewEntryList 
                                            entriesData={displayMyListEntries} 
                                            linkComponent={entryPageMyListLinkComponent} 
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            :
                            null
                        }
                </Grid>
            </Grid>
        </Page>
    )
}


function chunk(array, size) {
    if (!array) return [];

    const firstChunk = array.slice(0, size); // create the first chunk of the given array

    if (!firstChunk.length) {
        return array; // this is the base case to terminal the recursive
    }
    return [firstChunk].concat(chunk(array.slice(size, array.length), size));
}
